/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from 'react';
import { Heading, CenteredContainer, sharedStyles } from '../Typography';
import InputField from '../InputField';
import NewInputField from '../InputField/inputField';
import { styled } from 'styled-components';
import AutoCompleteDropdown from '../SelectField/AutoCompleteDropdown';
import Checkbox from '@mui/material/Checkbox';
import Button from '../Button';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { get, post } from '../ApiHandler/apihandler';
import { SERVICES } from '../Services';
import fetchData from '../FetchData';
import Loader from '../Loader/Loader';
import { Box } from '@mui/material';
import JuspayLogo from '../../assets/icons/juspaylogonew.svg';
import YesbankLogo from '../../assets/icons/yesbanklogo.png';
import ViSa from '../../assets/images/visa.jpg';
import MasTer from '../../assets/images/master.jpg';
import RuPay from '../../assets/images/rupay.jpg';
import AxisBank from '../../assets/images/axis-bank-logo.jpg';
import PaytmLogo from '../../assets/images/Paytm_logo.jpg';
const FormController = styled.form`
  display: flex;
  flex-direction: column;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  box-shadow: 20px 0 10px -20px rgba(0, 0, 0, 0.45) inset;
  margin-top: 10px;
  padding-bottom: 30px;
  box-shadow: -20px 0 10px -20px rgba(0, 0, 0, 0.45) inset,
    20px 0 10px -20px rgba(0, 0, 0, 0.45) inset;
  width: 50%;
  @media (max-width: 1024px) {
    padding-bottom: 0px;
    width: 100%;
  }
`;
const CenteredContainer1 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-left: 40px;
  padding-right: 40px;
  @media (max-width: 768px) {
    padding-left: 25px;
    padding-right: 25px;
  }
`;
const Text = styled.p`
  ${sharedStyles}
  font-weight: 500;
  font-size: 15px;
  margin-top: 5px;
  min-width: auto;
  color: #0093b5;
  @media (max-width: 768px) {
    min-width: unset;
    width: 100%;
    font-size: 12px;
  }
`;

const ImportantTextContainer = styled.div`
  background: rgba(252, 170, 232, 0.2);
`;
const BoxContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0px;
`;
const ImpText = styled.p`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 175%;
  margin: 0 0;
  padding: 10px;
  padding-left: 40px;
  color: ${(props) => props.color || '#00000'};
  @media (max-width: 768px) {
    padding-left: 20px;
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  gap: 10px;
  // width: 40%;
  min-width: unset;
  margin: 0;
  padding-left: 40px;
  @media (max-width: 768px) {
    min-width: unset;
    padding-left: 5px;
  }
`;
const CentBox = styled.div`
  list-style: none;
  padding: 0px;
  margin: 0px;
  float: left;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #ddd;
  border-radius: 7px;
  margin-bottom: 15px;
  @media (max-width: 768px) {
    min-width: unset;
    padding-left: 5px;
  }
`;
const ChooseBoxe = styled.div`
  display: flex;
  margin-top: 10px;
  justify-content: flex-start;
  padding-left: 30px;
  padding-right: 30px;
  box-sizing: border-box;
  width: 100%;
  @media (max-width: 767px) {
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
  }
`;
const DebCardwrp = styled.div`
  display: flex;
  flex-direction: column;
`;
const CboxCrin = styled.div`
  list-style: none;
  padding: 15px;
  margin: 0px;
  float: left;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #ddd;
  @media (max-width: 768px) {
    min-width: unset;
    padding-left: 5px;
  }
`;

const Inpboxe = styled.div`
  width: 42px;
  float: left;
  padding-top: 5px;
  @media (max-width: 768px) {
    min-width: unset;
    padding-left: 5px;
  }
`;

const DebCardnwupi = styled.div`
  float: left;
  width: auto;
  color: #545454;
  font-size: 14px;
  font-weight: bold;
  @media (max-width: 768px) {
    min-width: unset;
    padding-left: 5px;
  }
`;
const DebCardlist = styled.div`
  float: left;
  width: auto;
  padding-left: 0px;
  @media (max-width: 768px) {
    min-width: unset;
    padding-left: 5px;
  }
`;
const PoBy = styled.span`
  display: block;
  font-size: 12px;
  font-weight: normal;
  color: #9e9e9e;
`;

const CvC = styled.span`
  float: left;
  width: 45px;
  height: 26px;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 0;
  margin-right: 7px;
  overflow: hidden;
  text-align: center;
`;

const MvC = styled.span`
  float: left;
  width: 45px;
  height: 26px;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 0;
  overflow: hidden;
  text-align; center;
  margin-right: 7px;
`;

const RvC = styled.span`
  float: left;
  width: 60px;
  height: 26px;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 0;
  text-align: center;
  margin-right: 7px;
`;

const AmC = styled.span`
  float: left;
  width: 45px;
  height: 26px;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 0;
  margin-right: 7px;
`;

const MooR = styled.span`
  background: transparent;
  border: none;
  float: left;
  height: auto;
  width: auto;
  line-height: 25px;
  font-size: 12px;
  color: #9e9e9e;
`;
const PowerBy = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
`;
const HeadingForMobile = styled(Heading)`
  color: #006a61;
  justify-content: flex-start;
  padding-left: 40px;
  margin-bottom: 15px;
  @media (max-width: 768px) {
    font-size: 22px;
    padding: 0px 20px;
    line-height: normal;
  }
`;

const getOptionsForUin = (options, key) =>
  options?.map((opt) => ({
    ...opt,
    label: opt[key].replace(/_/g, ' '),
    value: opt[key],
  }));
const Form = () => {
  const [contributionAmount, setContributionAmount] = useState('');
  const [selectedUinType, setSelectedUinType] = useState('');
  const [userData, setUserData] = useState({});
  const [memberUin, setMemberUin] = useState({});
  const [isCheckbox1Checked, setIsCheckbox1Checked] = useState(false);
  const [isCheckbox2Checked, setIsCheckbox2Checked] = useState(false);
  const memberId = useSelector((state) => state.member.memberId);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [uinValue, setUinValue] = useState('');
  const [paymentGatewayType, setPaymentGatewayType] = useState('');
  const [defaultDonationPurpose, setDefaultDonationPurpose] = useState('');
  const [ip, setIP] = useState('');
  const [paymentData, setPaymentData] = useState({});

  const fetchUserData = useCallback(async () => {
    const url = SERVICES.MEMBER_DETAILS(memberId);
    await fetchData(url, setUserData, dispatch, setIsLoading);
  }, [memberId, dispatch]);

  useEffect(() => {
    fetchUserData();
    getDefaultReceipt();
  }, [fetchUserData]);

  const handleUinValue = (value) => {
    setUinValue(value);
  };

  const uinType = [
    { name: 'PAN CARD', value: 'PAN_CARD' },
    { name: 'AADHAR CARD', value: 'AADHAR_CARD' },
    { name: 'VOTER CARD', value: 'VOTER_CARD' },
    { name: 'DRIVING LICENSE', value: 'DRIVING_LICENSE' },
    { name: 'PASSPORT', value: 'PASSPORT' },
  ];

  const getDefaultReceipt = async () => {
    try {
      const url = `${SERVICES.CONTRIBUTION_CYCLE}/defaultDonationPurpose`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        setDefaultDonationPurpose(data?.data?.name);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  const getIp = async () => {
    const response = await fetch('https://api.ipify.org/?format=json', {
      method: 'GET',
    });
    if (response.ok) {
      const data = await response.json();
      setIP(data?.ip);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!contributionAmount) {
      toast.error('Please Select an Amount.', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
        closeButton: false,
      });
      return;
    }
    if (
      selectedUinType === 'PAN_CARD' &&
      !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(uinValue)
    ) {
      toast.error(`Please enter a valid PAN.\nFor Example: XXXXX9999X`, {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
        closeButton: false,
      });
      return;
    }
    if (
      selectedUinType === 'AADHAR_CARD' &&
      !/^[2-9]{1}[0-9]{11}$/.test(uinValue)
    ) {
      toast.error(
        `Please enter a valid Aadhaar Number.\nFor Example 999999999999`,
        {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          draggable: true,
          closeButton: false,
        }
      );
      return;
    }
    if (
      selectedUinType === 'VOTER_CARD' &&
      !/^[a-zA-Z0-9 -]{5,20}$/.test(uinValue)
    ) {
      toast.error(`Please enter a valid Elector's Photo Identity Number.`, {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
        closeButton: false,
      });
      return;
    }
    if (
      selectedUinType === 'DRIVING_LICENSE' &&
      !/^[a-zA-Z0-9 -]{5,20}$/.test(uinValue)
    ) {
      toast.error(`Please enter a valid Driving License Number.`, {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
        closeButton: false,
      });
      return;
    }
    if (
      selectedUinType === 'PASSPORT' &&
      !/^[A-Z]{1}[0-9]{7}$/.test(uinValue)
    ) {
      toast.error(
        `Please enter a valid Passport Number.\nFor Example JXXXXXXX`,
        {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          draggable: true,
          closeButton: false,
        }
      );
      return;
    }

    if (!isCheckbox1Checked || !isCheckbox2Checked) {
      toast.error('Please Select All Checkboxes.', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
        closeButton: false,
      });
      return;
    }
    if (!paymentGatewayType) {
      toast.error('Please Select Payment Gateway', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
        closeButton: false,
      });
      return;
    }

    const url = SERVICES.CONTRIBUTION_FORM;
    let returnUrl;
    if (paymentGatewayType === 'EASEBUZZ' || paymentGatewayType === 'PAYTM') {
      returnUrl = null;
    } else {
      returnUrl = SERVICES.JUSPAY_RETURN_URL;
    }
    try {
      const response = await post(url, {
        amount: contributionAmount,
        uinType: selectedUinType,
        returnUrl,
        uinNumber: uinValue,
        paymentGatewayType,
        ipAddress: ip,
      });
      if (response.ok) {
        const data = await response.json();
        setPaymentData(data.data);
        const paymentLink = data.data.webPaymentLink;
        if (paymentLink) {
          window.location.href = paymentLink;
        }
      }
      if (response.status === 422) {
        toast.error(
          'Online Contribution is not active, Please contact helpdesk!',
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            draggable: true,
            closeButton: false,
          }
        );
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  const handleContAmount = (newValue) => {
    setContributionAmount(newValue);
  };
  const getMemberUin = async () => {
    try {
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/uin`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setUinValue(data?.data[0]?.uin);
        setSelectedUinType(data?.data[0]?.uinType);
      } else {
        console.error('Failed to fetch Member Uin');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  const getMemberUinOnChange = async (uinType) => {
    try {
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/uin`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setMemberUin(data.data);
        const selectedUinEntry = data.data.find(
          (entry) => entry.uinType === uinType
        );
        if (selectedUinEntry) {
          setUinValue(selectedUinEntry?.uin);
          setSelectedUinType(selectedUinEntry?.uinType);
        } else {
          setUinValue('');
          console.error('No data found for the selected UIN type');
        }
      } else {
        console.error('Failed to find Selected Uin type');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  const handleCheckbox1Change = (event) => {
    setIsCheckbox1Checked(event.target.checked);
  };

  const handleCheckbox2Change = (event) => {
    setIsCheckbox2Checked(event.target.checked);
  };
  useEffect(() => {
    getMemberUin();
    getIp();
  }, []);
  useEffect(() => {
    loadPaytmScript();
    const orderDetails = {
      mid: paymentData?.mid,
      orderId: paymentData?.orderId,
      txnToken: paymentData?.txnToken,
      amount: contributionAmount,
    };
    window.addEventListener('load', () => {
      initiatePaytmCheckout(orderDetails);
    });
  }, []);

  const loadPaytmScript = () => {
    const script = document.createElement('script');
    script.src = `https://securegw.paytm.in/merchantpgpui/checkoutjs/merchants/pGhrTf06967552127873.js`;
    script.async = true;
    script.onload = () => console.log('Paytm script loaded successfully.');
    script.onerror = () => console.error('Failed to load Paytm script.');
    document.body.appendChild(script);
  };

  const initiatePaytmCheckout = (orderDetails) => {
    if (window.Paytm && window.Paytm.CheckoutJS) {
      window.Paytm.CheckoutJS.init({
        root: '',
        style: {
          bodyBackgroundColor: '#ffffff',
          bodyColor: '',
          themeBackgroundColor: '#0FB8C9',
          themeColor: '#ffffff',
          headerBackgroundColor: '#284055',
          headerColor: '#ffffff',
          errorColor: '',
          successColor: '',
          card: {
            padding: '',
            backgroundColor: '',
          },
        },
        data: {
          orderId: orderDetails.orderId,
          token: orderDetails.txnToken,
          tokenType: 'TXN_TOKEN',
          amount: orderDetails.amount,
        },
        merchant: {
          mid: orderDetails.mid,
          redirect: true,
        },
        handler: {
          notifyMerchant: function (eventName, data) {
            console.log('EventName => ', eventName);
            console.log('Data => ', data);
          },
        },
      })
        .then(function () {
          window.Paytm.CheckoutJS.invoke();
        })
        .catch(function (error) {
          console.error('Error => ', error);
        });
    } else {
      console.error('Paytm SDK not loaded.');
    }
  };
  useEffect(() => {
    if (paymentData) {
      const orderDetails = {
        mid: paymentData?.mid,
        orderId: paymentData?.orderId,
        txnToken: paymentData?.txnToken,
        amount: contributionAmount,
      };
      initiatePaytmCheckout(orderDetails);
    }
  }, [paymentData]);
  return (
    <>
      <FormController onSubmit={handleSubmit}>
        <HeadingForMobile margin="20px">
          Enter Contribution Amount
        </HeadingForMobile>
        <CenteredContainer1>
          <InputField
            showIcon={true}
            placeholder="Contribution Amount"
            showAmount={true}
            value={contributionAmount}
            onChange={handleContAmount}
          />
          <Text>
            Thank you, UIN detail provided by you earlier is given below.
          </Text>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '15px',
              marginBottom: '20px',
              width: '100%',
            }}
          >
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              options={getOptionsForUin(uinType, 'value')}
              name="uinType"
              value={selectedUinType}
              onChange={(selectedValue) => {
                setSelectedUinType(selectedValue?.value);
                getMemberUinOnChange(selectedValue?.value);
              }}
              inputProps={{ required: true }}
              useHiddenInput
              label="Select Uin Type"
            />
            <NewInputField
              value={uinValue}
              onChange={(event) => {
                const { value } = event.target;
                handleUinValue(value);
              }}
            />
          </Box>
        </CenteredContainer1>
        <BoxContainer>
          <ImportantTextContainer>
            <ImpText color="#f4422a">
              As per latest Income Tax notification, UIN details are required
              for making contribution.
            </ImpText>
          </ImportantTextContainer>
        </BoxContainer>
        <CheckboxContainer>
          <Checkbox
            checked={isCheckbox1Checked}
            onChange={handleCheckbox1Change}
            sx={{
              color: '#D9D9D9;',
              '&.Mui-checked': {
                color: '#53A8A0;',
              },
            }}
          />
          <ImpText color="#484848" style={{ paddingLeft: '0px' }}>
            {/* I voluntarily donate this amount to Bharat Soka Gakkai towards
            Corpus fund. */}
            I voluntarily Donate this amount to "Bharat Soka Gakkai" towards:"
            {defaultDonationPurpose}"
          </ImpText>
        </CheckboxContainer>
        <CheckboxContainer>
          <Checkbox
            checked={isCheckbox2Checked}
            onChange={handleCheckbox2Change}
            sx={{
              color: '#D9D9D9;',
              '&.Mui-checked': {
                color: '#53A8A0;',
              },
            }}
          />
          <ImpText color="#484848" style={{ paddingLeft: '0px' }}>
            I confirm that I am an Indian Citizen.
          </ImpText>
        </CheckboxContainer>
        <ChooseBoxe>
          <Box sx={{ width: '100%' }}>
            <h2
              color="#484848"
              style={{
                textAlign: 'left',
                fontSize: '18px',
                paddingLeft: '0px',
                marginTop: '0',
              }}
            >
              Choose Preferred Payment Gateway
              <span
                style={{
                  display: 'flex',
                  textAlign: 'left',
                  fontSize: '14px',
                  paddingLeft: '0px',
                  marginTop: '0',
                  fontWeight: '500',
                  color: '#535353',
                }}
              >
                All transactions are secure and encrypted.
              </span>
            </h2>
            <CentBox
              onClick={() => {
                setPaymentGatewayType('EASEBUZZ');
              }}
            >
              <CboxCrin>
                <Inpboxe>
                  <span name="cards">
                    <input
                      type="radio"
                      value="EASEBUZZ"
                      checked={paymentGatewayType === 'EASEBUZZ'}
                      onChange={() => setPaymentGatewayType('EASEBUZZ')}
                    />
                  </span>
                </Inpboxe>
                <DebCardwrp>
                  <DebCardnwupi>
                    Debit Cards, Netbanking, Wallets and UPI
                    <PowerBy>
                      <PoBy>Powered by Yes Bank </PoBy>
                      <img
                        src={YesbankLogo}
                        alt="yes bank"
                        style={{ height: '26px', cursor: 'pointer' }}
                        onClick={() => {
                          setPaymentGatewayType('EASEBUZZ');
                        }}
                      />
                    </PowerBy>
                  </DebCardnwupi>
                  <DebCardlist>
                    <CvC>
                      <img
                        src={ViSa}
                        alt="visa"
                        style={{ height: '26px', cursor: 'pointer' }}
                      />
                    </CvC>
                    <MvC>
                      <img
                        src={MasTer}
                        alt="master"
                        style={{ height: '26px', cursor: 'pointer' }}
                      />
                    </MvC>
                    <RvC>
                      <img
                        src={RuPay}
                        alt="rupay"
                        style={{ height: '26px', cursor: 'pointer' }}
                      />
                    </RvC>
                    <MooR>and more...</MooR>
                  </DebCardlist>
                </DebCardwrp>
              </CboxCrin>
            </CentBox>
            {/* <CentBox>
              <CboxCrin>
                <Inpboxe>
                  <span name="cards">
                    <input
                      type="radio"
                      value="PAYTM"
                      checked={paymentGatewayType === 'PAYTM'}
                      onChange={() => setPaymentGatewayType('PAYTM')}
                    />
                  </span>
                </Inpboxe>
                <DebCardnwupi>
                  Debit Cards, Netbanking and UPI
                  <PowerBy>
                    <PoBy>Powered by Paytm </PoBy>
                    <img
                      src={PaytmLogo}
                      alt="Paytm"
                      style={{
                        height: '18px',
                        cursor: 'pointer',
                        marginLeft: '5px',
                      }}
                      onClick={() => setPaymentGatewayType('PAYTM')}
                    />
                  </PowerBy>
                </DebCardnwupi>
              </CboxCrin>
            </CentBox> */}
          </Box>
        </ChooseBoxe>
        <CenteredContainer>
          <Button type="submit">Submit</Button>
        </CenteredContainer>
      </FormController>
    </>
  );
};
export default Form;
